import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject, BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
//lodash
import * as _ from "lodash";
// excel export
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

@Injectable()
export class PraService {
  constructor(private http: HttpClient) { }

  // excel export
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  getEmployeeListAndStore(storeid: string) {
    return this.http
      .get<any>(
        environment.serverUrl +
        "/api/Employee/GetEmployeeListByStoreID?storeID=" +
        storeid
      )
      .pipe(
        map((res: any) => {
          // login successful if there's a jwt token in the response
          if (res) {
            return res;
          }
        })
      );
  }

  getGetPRAWeeks(storeDate: any, isWeekly: boolean, storeID: number) {
    return this.http
      .post<any>(
        environment.serverUrl +
        "/api/Data/GetPRAWeeks?IsWeekly=" +
        isWeekly +
        "&StoreDate=" +
        storeDate +
        "&StoreID=" +
        storeID,
        {
          IsWeekly: isWeekly,
          StoreDate: storeDate,
          StoreID: storeID
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  submitPRARequest(finalArray) {
    return this.http
      .post<any>(
        environment.serverUrl + "/api/Data/PRA_SubmitRequest",
        finalArray
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  submitPRARequestSuperAdmin(finalArray) {
    return this.http
      .post<any>(
        environment.serverUrl + "/api/Data/PRA_SubmitRequest_SuperAdmin",
        finalArray
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getPRARequests(
    loginUser: string,
    loginEmployeeID: number,
    isPayrollAdmin: boolean,
    userOpsLevel: number,
    requestStatusID: number,
    opsID: number,
    startDate: any,
    endDate: any,
    storeID: any,
    employeeID: number,
    selectedRegion: string
  ) {
    return this.http
      .post<any>(
        environment.serverUrl +
        "/api/Data/GetPRARequestsPlusDaily?loginUser=" +
        loginUser +
        "&loginEmployeeID=" +
        loginEmployeeID +
        "&isPayrollAdmin=" +
        isPayrollAdmin +
        "&userOpsLevel=" +
        userOpsLevel +
        "&RequestStatusID=" +
        requestStatusID +
        "&OpsID=" +
        opsID +
        "&StartDate=" +
        startDate +
        "&EndDate=" +
        endDate +
        "&StoreID=" +
        storeID +
        "&EmployeeID=" +
        employeeID +
        "&SelectedRegion=" +
        selectedRegion,
        {
          loginUser: loginUser,
          loginEmployeeID: loginEmployeeID,
          isPayrollAdmin: isPayrollAdmin,
          userOpsLevel: userOpsLevel,
          RequestStatusID: requestStatusID,
          OpsID: opsID,
          StartDate: startDate,
          EndDate: endDate,
          StoreId: storeID,
          EmployeeID: employeeID,
          SelectedRegion: selectedRegion
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getPRARequestsEID(
    loginUser: string,
    loginEmployeeID: number,
    isPayrollAdmin: boolean,
    userOpsLevel: number,
    requestStatusID: number,
    opsID: number,
    startDate: any,
    endDate: any,
    storeID: any,
    employeeID: number
  ) {
    return this.http
      .post<any>(
        environment.serverUrl +
        "/api/Data/GetPRARequestsPlusDaily?loginUser=" +
        loginUser +
        "&loginEmployeeID=" +
        loginEmployeeID +
        "&isPayrollAdmin=" +
        isPayrollAdmin +
        "&userOpsLevel=" +
        userOpsLevel +
        "&RequestStatusID=" +
        requestStatusID +
        "&OpsID=" +
        opsID +
        "&StartDate=" +
        startDate +
        "&EndDate=" +
        endDate +
        "&StoreID=" +
        storeID +
        "&EmployeeID=" +
        employeeID,
        {
          loginUser: loginUser,
          loginEmployeeID: loginEmployeeID,
          isPayrollAdmin: isPayrollAdmin,
          userOpsLevel: userOpsLevel,
          RequestStatusID: requestStatusID,
          OpsID: opsID,
          StartDate: startDate,
          EndDate: endDate,
          StoreId: storeID,
          EmployeeID: employeeID,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getStates() {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let storeList = user.storeList;

    var flags = [],
      output = [],
      l = storeList.length,
      i;
    for (i = 0; i < l; i++) {
      if (flags[storeList[i].State]) continue;
      flags[storeList[i].State] = true;
      output.push(storeList[i].State);
    }

    return output;
  }

  getRegion() {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let storeList = user.storeList;

    var flags = [],
      output = [],
      l = storeList.length,
      i;
    for (i = 0; i < l; i++) {
      if (flags[storeList[i].Region]) continue;
      flags[storeList[i].Region] = true;
      output.push(storeList[i].Region);
    }

    return output;
  }

  getProcessLevel() {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let storeList = user.storeList;
    // Filter to unique region names
    let uniqueList = _.uniqBy(storeList, "Region");

    //Create array of just region names
    let regionList = [];

    for (let i in uniqueList) {
      regionList.push(uniqueList[i].Region);
    }
    return regionList.sort();
  }

  getStores() {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let storeList = user.storeList;

    var flags = [],
      output = [],
      l = storeList.length,
      i;
    for (i = 0; i < l; i++) {
      if (flags[storeList[i].StoreID]) continue;
      flags[storeList[i].StoreID] = true;
      output.push({
        StoreID: storeList[i].StoreID,
        StoreName: storeList[i].StoreName,
        State: storeList[i].State,
      });
    }

    output.sort(function (a, b) {
      return a.StoreID - b.StoreID;
    });

    return output;
  }

  getPRADetails(requestID: any) {
    return this.http
      .post<any>(
        environment.serverUrl +
        "/api/Data/GetPRARequestByID?RequestID=" +
        requestID,
        {
          RequestID: requestID,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getPRADetailsPlusTotal(requestID: any) {
    return this.http
      .post<any>(
        environment.serverUrl +
        "/api/Data/GetPRARequestByIDPlusTotal?RequestID=" +
        requestID,
        {
          RequestID: requestID,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  cancelPRARequest(
    requestID: any,
    requestorEmployeeID: number,
    comment: string
  ) {
    return this.http
      .post<any>(
        environment.serverUrl +
        "/api/Data/CancelRequest?RequestID=" +
        requestID +
        "&RequstorEmployeeID=" +
        requestorEmployeeID +
        "&Comment=" +
        comment,
        {
          RequestID: requestID,
          RequestorEmployeeID: requestorEmployeeID,
          Comment: comment,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  completePRARequest(requestID: any, requestorEmployeeID: number) {
    return this.http
      .post<any>(
        environment.serverUrl +
        "/api/Data/CompletePRA?RequestID=" +
        requestID +
        "&RequestorEmployeeID=" +
        requestorEmployeeID,
        {
          RequestID: requestID,
          RequestorEmployeeID: requestorEmployeeID,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getDocList(requestID: any) {
    return this.http
      .post<any>(`${environment.serverUrl}/api/Data/GetDocumentsByRequestID?RequestID=${requestID}`,
        {
          RequestID: requestID
        }
      )
  }

  getDocById(
    documentID: any,
    documentName: any
  ) {
    return this.http
      .get(`${environment.serverUrl}/api/Data/DownloadDocumentByID?documentID=${documentID}&documentName=${encodeURIComponent(documentName)}`,
        { responseType: 'blob' }
      )
  }

  deleteDocById(
    documentID: any,
    auditEID: any
  ) {
    return this.http
      .post<any>(`${environment.serverUrl}/api/Data/RemoveDocumentByID?DocumentID=${documentID}&AuditEID=${auditEID}`,
        {
          DocumentID: documentID,
          AuditEID: auditEID
        }
      )
  }

  getAllPayrollAdmin() {
    return this.http
      .get<any>(
        environment.serverUrl +
        "/api/Employee/GetAllPayrollAdmin"
      )
      .pipe(
        map((res: any) => {
          // login successful if there's a jwt token in the response
          if (res) {
            return res;
          }
        })
      );
  }

  updatePayrollAdmin(loginUserID: string, regions: any) {
    return this.http
      .post<any>(
        environment.serverUrl +
        `/api/Employee/UpdatePayrollAdmin?loginUserID=${loginUserID}`,
        regions
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  formatMinutesToHours(minutes) {
    var minutes = minutes;
    var hours = (minutes / 60).toFixed(2);
    return hours;
  }
}
